"use client";

import React from "react";
import { ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { scrollToSection } from "@/lib/utils";

const MiddleTopSection = () => {
  return (
    <div className="flex flex-col justify-center px-5 sm:px-2.5">
      <h2 className="text-[30px] capitalize mb-6 leading-9">
        Let&apos;s Build Something Remarkable Together.
      </h2>
      <div className="flex space-x-4">
        <Button
          variant="outline"
          className="!px-4.5 group relative overflow-hidden"
          onClick={() => {
            const isMobile = window.innerWidth < 640;
            const targetId = isMobile ? "design-workk" : "design-work";
            scrollToSection(targetId);
          }}
        >
          Explore Our Work
          <div className="relative h-4 w-4 ml-1 overflow-hidden">
            <ArrowDown className="h-4 w-4 absolute transition-transform duration-300 transform translate-y-0 group-hover:translate-y-full" />
            <ArrowDown className="h-4 w-4 absolute transition-transform duration-300 transform -translate-y-full group-hover:translate-y-0" />
          </div>
        </Button>
        <Button onClick={() => scrollToSection("contact-us")}>
          Contact Us
        </Button>
      </div>
    </div>
  );
};

export default MiddleTopSection;
